import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHclComponent } from './simple-icons-hcl.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHclComponent ],
    exports:      [ SimpleIconsHclComponent ],
    bootstrap:    []
})
export class SimpleIconsHclModule {}
